import { render } from "./InputFreetextSmall.vue?vue&type=template&id=08c0738d&scoped=true"
import script from "./InputFreetextSmall.vue?vue&type=script&lang=js"
export * from "./InputFreetextSmall.vue?vue&type=script&lang=js"

import "./InputFreetextSmall.vue?vue&type=style&index=0&id=08c0738d&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-08c0738d"]])

export default __exports__